import './FileDownloadCell.scss';
import React, {useContext, useState} from 'react';
import {I18nReactContext} from "../../../../../contexts/I18nContext";
import {getCompanyFileDownloadLinkAPI} from "../../../../../Services/api";
import DownloadIcon from '@mui/icons-material/Download';
import {IconButton, Tooltip} from "@mui/material";

export const FileDownloadCell = ({fileId, signedUrl}) => {
    const {i18n} = useContext(I18nReactContext);
    const [loading, setLoading] = useState(false);

    const handleDownload = async () => {
        if (loading) return;

        setLoading(true);
        try {
            // Use the pre-generated signedUrl if available, otherwise fetch it
            const downloadUrl = signedUrl || await getCompanyFileDownloadLinkAPI({fileId});

            // Create a temporary link element and trigger the download
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', ''); // This will use the file's original name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading file:", error);
            alert(i18n.translate('superAdmin.assets.downloadError'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="FileDownloadCell">
            <Tooltip title={i18n.translate('superAdmin.assets.download')}>
                <IconButton 
                    onClick={handleDownload} 
                    disabled={loading}
                    className="downloadButton"
                >
                    <DownloadIcon />
                </IconButton>
            </Tooltip>
        </div>
    );
};
